module.exports = __webpack_public_path__ + "img/icb-co-Adv-e@2x.bb52beff.png";